export const navMobile = () => {

    const body = document.querySelector('body')
    const burgerButton = document.querySelector('.page-header-mobile .hamburger')
    const header = document.querySelector('.page-header')

    burgerButton.addEventListener('click', () => {
        burgerButton.classList.toggle('hamburger--open')
        header.classList.toggle('page-header--open')
        body.classList.toggle('freeze')
    });

}